import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FolderDto } from '@nusign/picflow-backend-types';

export function folderNameValidator(folders: FolderDto[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = folders.find(folder => folder.title === control.value);
    return forbidden ? { existingFolderName: { value: control.value } } : null;
  };
}
